import type { ButtonHTMLAttributes, CSSProperties } from 'react';

export type ButtonVariant = 'primary' | 'dark' | 'sage' | 'ghost' | 'outline';
export type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
}

const variantStyles: Record<ButtonVariant, CSSProperties> = {
  primary: {
    background: 'var(--terracotta)',
    color: '#fff',
    border: 0,
    boxShadow: '0 8px 20px -8px rgba(184,106,76,0.5)',
  },
  dark: {
    background: 'var(--ink)',
    color: '#fff',
    border: 0,
  },
  sage: {
    background: 'var(--sage-deep)',
    color: '#fff',
    border: 0,
  },
  ghost: {
    background: 'transparent',
    color: 'var(--ink-soft)',
    border: 0,
  },
  outline: {
    background: 'transparent',
    color: 'var(--ink)',
    border: '1px solid var(--line)',
  },
};

const sizeStyles: Record<ButtonSize, CSSProperties> = {
  sm: { padding: '8px 14px', fontSize: 13, borderRadius: 999 },
  md: { padding: '12px 22px', fontSize: 15, borderRadius: 14 },
  lg: { padding: '16px 28px', fontSize: 16, borderRadius: 16 },
};

export function Button({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  style,
  ...rest
}: ButtonProps) {
  return (
    <button
      style={{
        fontFamily: 'var(--sans)',
        fontWeight: 700,
        cursor: 'pointer',
        ...variantStyles[variant],
        ...sizeStyles[size],
        ...(fullWidth ? { width: '100%' } : {}),
        ...style,
      }}
      {...rest}
    />
  );
}
